import { render, staticRenderFns } from "./SmartwaiverWidget.vue?vue&type=template&id=3c002fd6&scoped=true&"
import script from "./SmartwaiverWidget.vue?vue&type=script&lang=ts&"
export * from "./SmartwaiverWidget.vue?vue&type=script&lang=ts&"
import style0 from "./SmartwaiverWidget.vue?vue&type=style&index=0&id=3c002fd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c002fd6",
  null
  
)

export default component.exports